import { useFormikContext } from 'formik';
import React from 'react';
import { InputLabel, Spacer } from 'src/common';
import Button from 'src/components/form/Button';
import MaterialInput from 'src/components/form/MaterialInput';
import { ActionDataType } from '../types';

interface AddCommentProps {}

export const AddComment: React.FC<AddCommentProps> = () => {
  const { values, setFieldValue, handleSubmit, isSubmitting, touched, errors, handleBlur } =
    useFormikContext<ActionDataType<'add-comment'>>();

  if (values.action !== 'add-comment') {
    return null;
  }

  const handleCommentChange = (value: string) => {
    setFieldValue('addCommentData.comment', value);
  };

  return (
    <>
      <InputLabel>COMMENT *</InputLabel>
      <MaterialInput
        name="addCommentData.comment"
        multiline
        minRows={3}
        maxRows={10}
        fullWidth
        placeholder="Enter your comment here..."
        value={values.addCommentData.comment}
        onChange={(e) => handleCommentChange(e.target.value)}
        onBlur={handleBlur}
        error={touched.addCommentData?.comment && !!errors.addCommentData?.comment}
        helperText={touched.addCommentData?.comment && errors.addCommentData?.comment}
        data-cy="comment-input"
      />
      <Spacer $px={32} />
      <Button
        primary
        css="width: 100%"
        onClick={() => handleSubmit()}
        disabled={!values.addCommentData.comment.trim() || isSubmitting}
        data-cy="submit-btn"
      >
        ADD
      </Button>
    </>
  );
};
